import React from 'react';
import { Container } from '../../UI/Container/Container';
import { PrismicHTMLParser } from '../../PrismicHTMLParser';
import { PrismicLink } from '../../PrismicLink';
import './PressList.scss';
import { Grid, GridRow, GridCol } from '../../UI/Grid';
import { SliceContext } from '../types';

type PressListItem = {
    press_list_image: {
        url: string | null;
    };
    press_list_title: string | null;
    press_list_content: {
        html: string | null;
    };
    press_list_link: {
        url: string;
        raw: {
            target: '_blank' | null;
        };
    };
};

type PressListSlice = {
    slice_type: 'press_list';
    primary: {
        press_list_number_of_columns: '2' | '3';
    };
    items: PressListItem[];
};

type PressListProps = {
    slice: PressListSlice;
    sliceContext: SliceContext;
};

class PressList extends React.Component<PressListProps> {
    render() {
        const items = this.props.slice.items;
        const nbrCol = this.props.slice.primary.press_list_number_of_columns;
        const colSize = nbrCol === '2' ? '6' : '4';

        return (
            <Container size="md">
                <Grid className="PressList">
                    <GridRow horizontalAlign={'h-start'} verticalAlign={'v-center'}>
                        {items.map((item, index) => (
                            <GridCol
                                colSize={colSize}
                                offsetSize={`0`}
                                mobileColSize={`12`}
                                tabletColSize={`6`}
                                key={index}
                            >
                                <div className="PressList-item">
                                    <div className="PressList-item-header">
                                        {item.press_list_image.url && (
                                            <img
                                                className="PressList-item-image"
                                                src={item.press_list_image.url}
                                            />
                                        )}
                                        <div className="PressList-item-title">
                                            {item.press_list_title}
                                        </div>
                                    </div>
                                    <PrismicHTMLParser className="PressList-item-content">
                                        {item.press_list_content.html}
                                    </PrismicHTMLParser>
                                    {/* TODO Remove this once we have actual icons */}
                                    <PrismicLink
                                        label="↗"
                                        link={item.press_list_link}
                                        className="PressList-item-link"
                                        slice={this.props.sliceContext}
                                    />
                                </div>
                            </GridCol>
                        ))}
                    </GridRow>
                </Grid>
            </Container>
        );
    }
}

export { PressList, PressListProps, PressListSlice, PressListItem };
